import { IApplicationState } from '../../types/redux';

export function getNewbuildingRating(state: IApplicationState) {
  return state.newbuildingInfo.rating;
}
